import React from "react"
import moment from 'moment';

import { StudioManager } from "../../studio-manager";
import Ticker from "react-ticker";

export class NowPlaying extends React.Component {
  state = {
    playingStream: false,
    show: ''
  }
  
  componentDidMount () {
    StudioManager.instance.on('airtime-play', this.airtimePlay);
    StudioManager.instance.on('airtime-stop', this.airtimeStop);
    StudioManager.instance.on('airtime-meta', this.airtimeMeta);
  }

  airtimePlay = () => this.setState({ playingStream: true });
  airtimeStop = () => this.setState({ playingStream: false });
  airtimeMeta = ({ show }) => this.setState({ show });

  render = () => (
    <div className="staff-picks" onClick={StudioManager.instance.toggleAirtime}>
      <div className="staff-picks__play">{ this.state.playingStream ? <div className="btn--stop" /> : <div className="btn--play" /> }</div>
      <div className="staff-picks__ticker">
      { this.state.show && <Ticker>{({ index }) => <div className="staff-picks__ticker__element">
        <b>NOW PLAYING</b>
        <span dangerouslySetInnerHTML={{__html: this.state.show}} />
        </div>}</Ticker>}
      </div>
    </div>
  )
}
